// extracted by mini-css-extract-plugin
export default {"bar":"SponsorBar_bar__PLN-A","sponsor":"SponsorBar_sponsor__kfzMm","fallback":"SponsorBar_fallback__+aqED"};